module.exports = __webpack_public_path__ + "img/product-tree.1e4fd73b.svg";